"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActiveRecognitionPay = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var pay_1 = require("../../model/pay");
var service_1 = require("../../../library/base/service");
var ActiveRecognitionPay = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(ActiveRecognitionPay, _super);
    function ActiveRecognitionPay() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '指纹支付激活接口';
        _this.code = '101027';
        _this.desc = '指纹支付激活接口';
        _this.requestParams = new pay_1.ActiveRecognitionPayRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return ActiveRecognitionPay;
}(service_1.BaseService));
exports.ActiveRecognitionPay = ActiveRecognitionPay;
//# sourceMappingURL=activeRecognitionPay.js.map